import React, { useState } from "react";
import {
  IonRow,
  IonCol,
  IonGrid,
  IonItem,
  IonLabel,
  IonIcon,
  IonItemDivider,
} from "@ionic/react";
import "./Preferences.scss";
import { isMobile } from "../../../utils/common";
import { Preferences_Checkbox } from "./Preferences_Checkbox";
import { PreferenceViewValidation, isUnsave } from "./PreferencesUtil";
import { Preferences_Radio } from "./Preferences_Radio";
import { ToolTip } from "app/components/ToolTip/ToolTip";
import { PREFERENCE_UNSAVED_TEXT } from "app/utils/constants";
const PreferencesListComponent: React.FC<any> = ({
  singleAccordion,
  handleAccordionChange,
  openSubheading,
  preferenceList,
  handleChange,
  isNone,
  isNoneMarTech,
  userInteractedPreferenceList
}) => {
  const handleCheck = (
    API_KEY: string,
    OPTION_TYPE: string,
    OPTION_VALUE: string | null
  ) => {
    let data: any = preferenceList.filter(
      (item: any) => item.key === API_KEY
    )[0];
    if (data && data.value) {
      switch (OPTION_TYPE) {
        case "radio":
          return data.value;
        case "checkbox":
          for (const [key, value] of Object.entries(data.value)) {
            if (OPTION_VALUE === key && value === "true") {
              return true;
            }
          }
          break;
        default:
          break;
      }
    }
  };
  const [toolTip, setTooltip] = useState<any>(null);
  return (
    <IonGrid
      className={
        isMobile ? `preferences-container-mobile` : `preferences-container-web`
      }
      data-testid={isMobile ? `preferences-container-mobile` : `preferences-container-web`}
    >
      <IonGrid class="preference-mobile">
        <IonRow>
          <IonCol size="10" className="preference-subheadings" data-testid="preference-subheading" >
            {singleAccordion.ACCORD_TITLE}
            <IonCol className="alert-preferences-container">
              {isUnsave(singleAccordion.ACORD_CONTENT, userInteractedPreferenceList) &&
                <IonIcon src="assets/icon/alert-preference.svg" className="alert-preferences"
                  onClick={() => setTooltip(PREFERENCE_UNSAVED_TEXT)}
                  onMouseEnter={() => setTooltip(PREFERENCE_UNSAVED_TEXT)}
                  onMouseLeave={() => setTooltip(null)}
                  data-testid="alert-preferences" />}
              <ToolTip message={toolTip} isActive={!!toolTip} />
            </IonCol>
          </IonCol>
          <IonCol
            className="ion-text-right preference-icon-container"
            onClick={() => {
              handleAccordionChange(singleAccordion.ACCORD_TITLE);
            }}
          >
            <IonIcon
              className="preference-ionicon"
              src={
                isMobile
                  ? `assets/icon/${
                      openSubheading === singleAccordion.ACCORD_TITLE
                        ? "minus-icon"
                        : "add"
                    }.svg`
                  : `assets/icon/grid-${
                      openSubheading === singleAccordion.ACCORD_TITLE
                        ? "up"
                        : "down"
                    }-arrow-thin.svg`
              }
            />
          </IonCol>
        </IonRow>
        {openSubheading === singleAccordion.ACCORD_TITLE &&
          singleAccordion.ACORD_CONTENT.map((content: any, index: number) => (
            <div key={content.CONTENT_TITLE} className="ion-margin-vertical">
              <IonRow>
                <IonCol className="preference-content">
                  {content.CONTENT_TITLE}
                </IonCol>
              </IonRow>
              <IonRow>
                {content.OPTION_TYPE === "radio" ? (
                  <IonCol className={isMobile ? "" : "preference-checkbox"}>
                    {content.CONTENT_VALUE.map((option: any, index: any) =>
                        PreferenceViewValidation(
                        singleAccordion.ACCORD_ROLE_FILTER_KEY,
                      (singleAccordion.ACCORD_ROLE_FILTER_KEY==="CAPACITY_TYPE") ? false : true,
                      (singleAccordion.ACCORD_ROLE_FILTER_KEY==="CAPACITY_TYPE") ? null : option?.OPTION_VALUE
                      ) ? (
                        <div
                          key={option.OPTION_TITLE}
                          className={isMobile ? "" : "radio-group"}
                        >
                          <Preferences_Radio 
                           preferenceList={preferenceList}
                           content={content}
                           option={option}
                           handleChange={handleChange}
                           handleCheck={handleCheck}
                          />
                          {index < content.CONTENT_VALUE.length - 1 &&
                          isMobile ? (
                            <IonItemDivider />
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <React.Fragment key={index} />
                      )
                    )}
                  </IonCol>
                ) : content.OPTION_TYPE === "checkbox" ? (
                  <IonCol class={isMobile ? "" : "preference-checkbox"}>
                    {content.CONTENT_VALUE.map((option: any, index: any) => (
                      <div key={option.OPTION_TITLE}>
                        <IonItem
                          key={option.OPTION_TITLE}
                          className="preference-checkalign"
                        >
                          <Preferences_Checkbox
                            option={option}
                            content={content}
                            handleChange={handleChange}
                            isNone={isNone}
                            isNoneMarTech={isNoneMarTech}
                            preferenceList={preferenceList}
                            ACCORD_TITLE={singleAccordion.ACCORD_TITLE}
                          />
                          <IonCol>
                            <IonLabel className="preference-label">{option.OPTION_TITLE}</IonLabel>
                          </IonCol>
                        </IonItem>
                        {index < content.CONTENT_VALUE.length - 1 &&
                        isMobile ? (
                          <IonItemDivider />
                        ) : (
                          ""
                        )}
                      </div>
                    ))}
                  </IonCol>
                ) : null}
              </IonRow>
              {index < singleAccordion.ACORD_CONTENT.length - 1 && !isMobile ? (
                <IonItemDivider />
              ) : (
                ""
              )}
            </div>
          ))}
      </IonGrid>
    </IonGrid>
  );
};

export default PreferencesListComponent;
